/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { useReducer } from 'react';
import { Button } from '../Button';
import './style.css';

export const CtaBlock = ({
    showFeaturedImage = false,
    title = 'Free & Open Source',
    showTagGroup = false,
    showMainTag = false,
    showLink = true,
    text = 'Whether you have a team of 2 or 200, our shared team inboxes keep everyone on the same page and in the loop.',
    stateProp,
    style,
    className,
    buttonTextLink = 'Button',
    buttonStyle = 'default',
    useHomepageCtaBlockStyleButton = false,
    outerBoxShouldUseFullWidth = false,
    onClick = () => {},
}) => {
    const [state] = useReducer(reducer, {
        state: stateProp || 'default',
        style: style || 'default',
    });

    let styleOverride = outerBoxShouldUseFullWidth ? { width: '100%' } : {};

    return (
        <div
            className={`cta-block style-1-${state.style} ${className}`}
            style={styleOverride}
            onMouseEnter={() => {
                // Uncommenting causes the button style to
                // change strangely and the text to be replaced by "Button"
                // Seems like we don't need it, so just comment it out here.
                //dispatch("mouse_enter");
            }}
            onMouseLeave={() => {
                // Since we don't use onMouseEnter, no need to use
                // onMouseLeave either
                //dispatch("mouse_leave");
            }}
        >
            <div
                className="text-and-supporting-wrapper"
                data-colors-mode="default"
            >
                <div className="text-and-supporting">
                    <div className="div-2">
                        {null == title ? null : (
                            <div className="text-2">{title}</div>
                        )}

                        <p className="supporting-text">{text}</p>
                        {showLink && (
                            <div
                                style={{
                                    display: 'inline-block',
                                    width: '100%',
                                }}
                            >
                                {null == buttonTextLink ? null : (
                                    <Button
                                        isHomepageCtaBlockButton={
                                            useHomepageCtaBlockStyleButton
                                        }
                                        className="button-instance"
                                        status="default"
                                        style={
                                            state.style === 'hover'
                                                ? 'default'
                                                : buttonStyle
                                        }
                                        textLink={
                                            state.style === 'hover'
                                                ? 'Button'
                                                : buttonTextLink
                                        }
                                        onClick={() => {
                                            onClick();
                                        }}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

function reducer(state, action) {
    if (state.state === 'default' && state.style === 'hover') {
        // eslint-disable-next-line default-case
        switch (action) {
            case 'mouse_leave':
                return {
                    state: 'default',
                    style: 'alt',
                };
        }
    }

    // eslint-disable-next-line default-case
    switch (action) {
        case 'mouse_enter':
            return {
                ...state,
                style: 'hover',
            };
    }

    return state;
}

CtaBlock.propTypes = {
    showFeaturedImage: PropTypes.bool,
    title: PropTypes.string,
    showTagGroup: PropTypes.bool,
    showMainTag: PropTypes.bool,
    showLink: PropTypes.bool,
    text: PropTypes.string,
    stateProp: PropTypes.oneOf(['default']),
    style: PropTypes.oneOf(['hover', 'alt', 'default']),
    buttonTextLink: PropTypes.string,
    buttonStyle: PropTypes.string,
    useHomepageCtaBlockStyleButton: PropTypes.bool,
    outerBoxShouldUseFullWidth: PropTypes.bool,
};
